export default "__VITE_ASSET__DKFabjfG__"